import { render, staticRenderFns } from "./OneQuestionPerPage.vue?vue&type=template&id=ac70beaa&scoped=true&"
import script from "./OneQuestionPerPage.vue?vue&type=script&lang=js&"
export * from "./OneQuestionPerPage.vue?vue&type=script&lang=js&"
import style0 from "./OneQuestionPerPage.vue?vue&type=style&index=0&id=ac70beaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac70beaa",
  null
  
)

export default component.exports